<template>
  <section class="all-store-settings">
    <section class="section-block">
      <SectionTitle :title="displayText.title" @edit="openDialog" />
      <BaseElForm label-position="left" label-width="250px">
        <BaseElFormItem :label="displayText.allClosed" class="settings-item">
          {{ formData.allClosed ? $t('common.open.text') : $t('common.close.text') }}
        </BaseElFormItem>
        <BaseElFormItem v-if="showControl.allExcludeTimeRules" :label="displayText.allExcludeTimeRules" class="settings-item">
          <div class="grid gap-[12px]">
            <p v-for="(item, index) in renderExcludeTime(formData.allExcludeTimeRules)" :key="index">
              {{ item }}
            </p>
          </div>
        </BaseElFormItem>
      </BaseElForm>
    </section>
    <AllStoreSettingsDialog
      v-if="showDialog"
      :visible="showDialog"
      :formData="formData"
      :formRules="formRules"
      @close="onCancel"
      @confirm="onConfirm"
    />
  </section>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import { GetShopBusinessTimeConfig, UpdateShopBusinessTimeConfig } from '@/api/shopBusinessTime'
import { useShop } from '@/use/shop'
import { get } from 'lodash'
import { useBusinessTime } from '@/use/useBusinessTime'
import { i18n } from '@/plugins/i18n/i18n'
import AllStoreSettingsDialog from './AllStoreSettingsDialog.vue'

export default defineComponent({
  name: 'AllStoreSettings',
  components: { AllStoreSettingsDialog },
  setup () {
    const {
      syncShopExcludeTimeRules,
      formatExcludeTime,
      renderExcludeTime,
    } = useBusinessTime()
    const { shopId } = useShop()
    const formBusinessRef = ref(null)
    const showDialog = ref(false)
    const displayText = computed(() => {
      const data = {
        title: '全店公休',
        allClosed: '全店公休',
        allExcludeTimeRules: '全店公休時段',
      }
      return data
    })
    const showControl = computed(() => {
      const controls = {
        allExcludeTimeRules: formData.allClosed,
      }
      return controls
    })
    const formData = reactive({
      allClosed: false,
      allExcludeTimeRules: [],
    })

    const formRules = {
      allExcludeTimeRules: [{ required: true, message: '請選擇全店公休時間', trigger: 'change' }],
    }

    const getShopBusinessTimeConfig = async () => {
      const [res, err] = await GetShopBusinessTimeConfig({
        shopId: shopId.value,
      })
      if (err) {
        window.$message.error(err)
        return
      }
      formData.allExcludeTimeRules = syncShopExcludeTimeRules(get(res, 'allExcludeTimeRules'))
      formData.allClosed = formData.allExcludeTimeRules.length > 0
    }

    const openDialog = () => {
      showDialog.value = true
    }

    const updateShopBusinessTimeConfig = async (data) => {
      const { allExcludeTimeRules, allClosed } = data
      const [, err] = await UpdateShopBusinessTimeConfig({
        shopId: shopId.value,
        allExcludeTimeRules: allClosed ? formatExcludeTime(allExcludeTimeRules) : [],
      })
      if (err) {
        window.$message.error(err)
        return
      }
      window.$message.success(i18n.t('common.message.updateSuccess'))
      await getShopBusinessTimeConfig()
    }

    const onConfirm = async (data) => {
      await updateShopBusinessTimeConfig(data)
      showDialog.value = false
    }

    const onCancel = () => {
      showDialog.value = false
    }

    onMounted(() => {
      getShopBusinessTimeConfig()
    })

    return {
      showDialog,
      formData,
      formRules,
      formBusinessRef,
      onCancel,
      onConfirm,
      openDialog,
      renderExcludeTime,
      displayText,
      showControl,
    }
  },
})
</script>

<style scoped>
</style>
